module.exports = __webpack_public_path__ + "img/journeybinder_logo.59782962.png";